<template>
    <button :disabled="loading" class="flex items-center">
        <i v-if="loading" class="fad fa-spin fa-spinner mr-2" />
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        loading: Boolean
    }
};
</script>
